(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cn-collection-with-filters"] && !Shopify.designMode) return;
  try {
    
  // JavaScript to show and hide values for the brand search for cn-collection-filters.
  // We render that snippet in a for loop so we include it here so its only added once.
  document.addEventListener('DOMContentLoaded', function() {
    const searchInput = document.getElementById('brand-search-input');
    const brandItems = document.querySelectorAll('.brand-item');
    
    // add event listener for brand search bar to filter results when searching
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        const searchTerm = this.value.toLowerCase();
        
        // Filter brand items by hiding items that do not match the search term
        brandItems.forEach(function(item) {
          const brandName = item.dataset.brand;
          
          if (brandName.includes(searchTerm)) {
            item.classList.remove('d-none');
          } else {
            item.classList.add('d-none');
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();
})();
